export enum DataFieldListItemPropertyType {
    Text = "Text",
    Number = "Number"
}